export const DEFAULT_EXAM_TYPES = [
  'Hemograma', 'Bioquímica', 'Parasitologia', 'Parasitologia de swab de traqueia',
  'Hemoparasitas', 'Microbiologia', 'Endoscopia', 'Radiografia (RX)',
  'Ultrassonografia', 'Outros'
];
